import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static targets = ["chat"]

  connect() {
    console.log("chat connected!")
    window.acc = this.CreateActionCableChannel();
    console.log(window.acc)

    // Load filter states from localStorage
    this.loadFilterStates();

    $(".btn-chat").on("click", function (e) {
      e.preventDefault();

      // Get target phone from dropdown
      const targetPhone = $("#target_phone").val() || "all";

      window.acc.perform("msg", {
        msg: $("#msg").val(),
        target_phone: targetPhone
      })

    })

    $(".btn-actbtn").on("click", function (e) {
      e.preventDefault()
      console.log("actbtn")

      // Get target phone from dropdown
      const targetPhone = $("#target_phone").val() || "all";

      window.acc.perform("act", {
        act: $(this).data("act"),
        msg: $(this).data("msg"),
        extra: $(this).data("extra"),
        target_phone: targetPhone
      })

    })

    $(".btn-adbbtn").on("click", function (e) {
      e.preventDefault()
      console.log("adbbtn")

      // Get target phone from dropdown
      const targetPhone = $("#target_phone").val() || "all";

      window.acc.perform("act", {
        act: 'adb_shell',
        msg: $("#adb_msg").val(),
        target_phone: targetPhone
      })

    })

    // Add click handler for phone modal
    $(document).on("click", ".btn-who-modal", (e) => {
      e.preventDefault();
      const phoneElement = $(e.target).closest('.phone-item');
      const phoneId = phoneElement.data('duid');

      if (phoneId) {
        this.loadPhoneInfo(phoneId);
      }
    });
  }

  loadFilterStates() {
    // Load subscription events filter state
    const hideSubscriptionEvents = localStorage.getItem('chat_hide_subscription_events') === 'true';
    this.hideSubscriptionEvents = hideSubscriptionEvents;

    // Load battery events filter state
    const hideBatteryEvents = localStorage.getItem('chat_hide_battery_events') === 'true';
    this.hideBatteryEvents = hideBatteryEvents;

    // Update UI checkboxes to reflect loaded states
    const subscriptionCheckbox = document.getElementById('hideSubscriptionEvents');
    if (subscriptionCheckbox) {
      subscriptionCheckbox.checked = hideSubscriptionEvents;
    }

    const batteryCheckbox = document.getElementById('hideBatteryEvents');
    if (batteryCheckbox) {
      batteryCheckbox.checked = hideBatteryEvents;
    }

    // Apply the filter classes
    this.updateChatFilterClass();
  }

  saveFilterStates() {
    localStorage.setItem('chat_hide_subscription_events', this.hideSubscriptionEvents.toString());
    localStorage.setItem('chat_hide_battery_events', this.hideBatteryEvents.toString());
  }

  loadPhoneInfo(phoneId) {

    phoneId = phoneId.split(":").pop();

    // Get API key from meta tag
    const apiKeyMetaTag = document.querySelector('meta[name="api-key"]');
    const apiKey = apiKeyMetaTag ? apiKeyMetaTag.getAttribute('content') : null;

    if (!apiKey) {
      console.error('API key not found in meta tags');
      return;
    }

    // Show the existing modal
    $('#whoModal').modal('show');

    // Update modal title to show loading
    $('#whoModalLabel').text('Loading phone information...');

    // Make API call to get phone information
    fetch(`/api/v1/phones/${phoneId}?apikey=${apiKey}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        this.updatePhoneModalTitle(data);
      })
      .catch(error => {
        console.error('Error loading phone information:', error);
        $('#whoModalLabel').text('Error loading phone information');
      });
  }

  updatePhoneModalTitle(phoneData) {
    // Extract phone data from nested structure
    const phone = phoneData.data || phoneData;

    // Update modal title with phone name/ID
    const phoneName = phone.name || phone.device_id || phone.id || 'Unknown Phone';
    $('#whoModalLabel').text(phoneName);

    // Update the screen image if recent_cap is available
    if (phoneData.recent_cap) {
      $('#who-screen').attr('src', phoneData.recent_cap);
    }

    // Update screen dimensions if available
    if (phone.screen_w && phone.screen_h) {
      // Store screen dimensions globally for the modal's JavaScript
      window.screen_w = phone.screen_w;
      window.screen_h = phone.screen_h;

      // Trigger a custom event to notify the modal that dimensions have changed
      $(document).trigger('phoneDimensionsUpdated', [phone.screen_w, phone.screen_h]);
    }

    // Add phone info to the existing modal if there's a place for it
    // You can add this info to the existing modal structure as needed
    if (phone.status) {
      // Add status info to the modal if there's a suitable place
      console.log('Phone loaded:', phone);
    }
  }



  CreateActionCableChannel() {
    // Get phone_session_token from meta tag or data attribute
    const phoneSessionTokenMetaTag = document.querySelector('meta[name="phone-session-token"]')
    const phoneSessionToken = phoneSessionTokenMetaTag ? phoneSessionTokenMetaTag.getAttribute('content') : this.element.dataset.phoneSessionToken

    // Use standard ChatChannel name with phone_session_token as parameter
    const channelName = "ChatChannel"

    const self = this

    return consumer.subscriptions.create(channelName, {
      connected() {
        console.log("Channel connected!")
        console.log("Connected to channel:", channelName)
      },

      disconnected() {
        console.log("Channel disconnected!")
      },

      received(data) {
        self.handleMessage(data)
      }
    })
  }

  toggleSubscriptionEvents(event) {
    console.log('toggleSubscriptionEvents called', event.target.checked);
    this.hideSubscriptionEvents = event.target.checked;
    this.updateChatFilterClass();
    this.saveFilterStates();
  }

  toggleBatteryEvents(event) {
    console.log('toggleBatteryEvents called', event.target.checked);
    this.hideBatteryEvents = event.target.checked;
    this.updateChatFilterClass();
    this.saveFilterStates();
  }

  updateChatFilterClass() {
    const chatElement = document.getElementById('chat');
    console.log('updateChatFilterClass called', chatElement, this.hideSubscriptionEvents);
    if (!chatElement) return;

    // Remove existing filter classes
    chatElement.classList.remove('hide-subscription-events');
    chatElement.classList.remove('hide-battery-events');

    // Add appropriate filter classes
    if (this.hideSubscriptionEvents) {
      chatElement.classList.add('hide-subscription-events');
      console.log('Added hide-subscription-events class');
    }

    if (this.hideBatteryEvents) {
      chatElement.classList.add('hide-battery-events');
      console.log('Added hide-battery-events class');
    }
  }

  handleMessage(data) {
    //$("#chat").prepend("<div><b>"+data.from+"</b>"+data.msg+"</div>")
    var ignoreLog = [
      'subscribed',
      'unsubscribed',
      'battery_level',
    ]
    if (!ignoreLog.includes(data.act) || data.duid.startsWith("user")) {
      console.log("handleMessage", data)
    }

    if (data.act == "subscribed") {
      this.addPhone(data.duid)
    }
    if (data.act == "unsubscribed") {
      this.removePhone(data.duid)
    }

    // Handle battery level updates
    if (data.act == "battery_level" || data.resp == "battery_level") {
      this.updateBatteryLevel(data.duid, data.msg)
    }

    var extra_data = false
    var extra_html = ''
    if (data.extra) {
      extra_data = data.extra
      extra_html = JSON.stringify(data.extra)
    }

    if (extra_data && data.resp == "cap") {
      console.log("cap", extra_data.upload.file.url)
      extra_html = '<a href="' + extra_data.upload.file.url + '" target="_blank"><img src="' + extra_data.upload.file.url + '" style="max-width:100px"></a>'
    }

    if (extra_data && (data.resp == "tapncap") && extra_data.upload) {
      console.log("tapncap", extra_data.upload.file.url)
      $("#who-screen").attr("src", extra_data.upload.file.url)
      extra_html = '<a href="' + extra_data.upload.file.url + '" target="_blank"><img src="' + extra_data.upload.file.url + '" style="max-width:100px"></a>'
    }
    // if (extra_data && (data.resp == "tapncap") && extra_data.upload_url) {
    //   console.log("tapncap", extra_data.upload_url)
    //   $("#who-screen").attr("src", extra_data.upload_url)
    //   extra_html = '<a href="' + extra_data.upload_url + '" target="_blank"><img src="' + extra_data.upload_url + '" style="max-width:100px"></a>'
    // }

    if (extra_data && (data.resp == "fas_uidump") && extra_data.xml) {
      extra_html = '<pre class="xml">' + _.escape(extra_data.xml) + '</pre>'
    }



    var dmsg = ""
    if (data.msg) {
      dmsg = data.msg.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
        .replace(/(?:\r\n|\r|\n)/g, '<br>')
    }

    var currentdate = new Date();
    var dtz = currentdate.toISOString();

    // Add target phone badge if present
    var target_badge = ""
    if (data.target_phone && data.target_phone != "all") {
      target_badge = '<span class="badge bg-info ms-1">' + data.target_phone + '</span>'
    }

    // Determine message type classes
    var messageTypeClass = 'chat-message-type-default';
    if (data.act === 'subscribed') {
      messageTypeClass = 'chat-message-type-subscription';
    } else if (data.act === 'unsubscribed') {
      messageTypeClass = 'chat-message-type-unsubscription';
    } else if (data.resp) {
      messageTypeClass = 'chat-message-type-resp-' + data.resp;
    }

    var msg_html = '<div class="chat-message ' + messageTypeClass + '">' +
      '<div class="chat-message-header">' +
      '<span class="chat-message-time"><span class="smart-time" data-utc="' + dtz + '">' + dtz + '</span></span>' +
      '<span class="chat-message-from"><b>' + data.from + '</b></span>' +
      target_badge +
      '</div>' +
      '<div class="chat-message-content">' +
      '<span class="chat-message-act">' + data.act + '</span>' +
      (dmsg ? ': ' + dmsg : '') +
      (extra_html ? '<div class="chat-message-extra">' + extra_html + '</div>' : '') +
      '</div>' +
      '</div>'

    $("#chat").prepend(msg_html);

    SDT.reloadSmartTimes();
  }

  addPhone(duid) {
    // Check if phone already exists
    if ($("#chat-who div[data-duid='" + duid + "']").length > 0) {
      // Update existing phone to connected status
      this.updatePhoneConnection(duid, true)
      return
    }

    // Find phone name from existing elements or use duid
    var phoneName = duid
    var existingPhone = $("#chat-who div[data-duid='" + duid + "']")
    if (existingPhone.length > 0) {
      phoneName = existingPhone.find('.phone-name a').text()
    }

    var phoneHtml = `
      <div class="phone-item connected" data-duid="${duid}" style="opacity: 0; transform: translateX(-20px);">
        <div class="phone-status">
          <i class="fa fa-circle text-success"></i>
        </div>
        <div class="phone-info">
          <div class="phone-name">
            <a href="#" class="btn-who-modal">${phoneName}</a>
          </div>
        </div>
      </div>
    `

    $("#chat-who").append(phoneHtml)

    // Animate the new phone item
    setTimeout(() => {
      $(`#chat-who div[data-duid='${duid}']`).css({
        'opacity': '1',
        'transform': 'translateX(0)'
      })
    }, 50)

    this.updatePhoneCount()
    this.animatePhoneCount()
  }

  removePhone(duid) {
    // Instead of removing, just update to disconnected status
    this.updatePhoneConnection(duid, false)
  }

  updatePhoneConnection(duid, isConnected) {
    var phoneElement = $("#chat-who div[data-duid='" + duid + "']")

    if (phoneElement.length > 0) {
      if (isConnected) {
        phoneElement.removeClass('disconnected').addClass('connected')
        phoneElement.find('.phone-status i').removeClass('text-muted').addClass('text-success')
      } else {
        phoneElement.removeClass('connected').addClass('disconnected')
        phoneElement.find('.phone-status i').removeClass('text-success').addClass('text-muted')
      }
    }
  }

  updatePhoneStatus(duid, status) {
    var phoneElement = $("#chat-who div[data-duid='" + duid + "']")
    if (phoneElement.length > 0) {
      var statusIcon = phoneElement.find('.phone-status i')

      // Update status based on poll_status
      switch (status) {
        case 0: // Offline
          phoneElement.removeClass('connected').addClass('disconnected')
          statusIcon.removeClass('text-success').addClass('text-muted')
          break
        case 1: // Polling
          phoneElement.removeClass('disconnected').addClass('connected')
          statusIcon.removeClass('text-muted').addClass('text-success')
          break
        case 2: // Live
          phoneElement.removeClass('disconnected').addClass('connected')
          statusIcon.removeClass('text-muted').addClass('text-success')
          break
        default:
          phoneElement.removeClass('connected').addClass('disconnected')
          statusIcon.removeClass('text-success').addClass('text-muted')
      }
    }
  }

  updateBatteryLevel(duid, batteryLevel) {
    var phoneElement = $("#chat-who div[data-duid='" + duid + "']")
    if (phoneElement.length > 0) {
      var batteryIndicator = phoneElement.find('.battery-indicator')
      if (batteryIndicator.length === 0) {
        // Create battery indicator if it doesn't exist
        var batteryHtml = `
          <span class="battery-indicator" title="Battery Level">
            <i class="fa fa-battery-${this.getBatteryIconLevel(batteryLevel)}"></i>
            ${batteryLevel}%
          </span>
        `
        phoneElement.find('.phone-meta').append(batteryHtml)
      } else {
        // Update existing battery indicator
        batteryIndicator.find('i').attr('class', `fa fa-battery-${this.getBatteryIconLevel(batteryLevel)}`)
        batteryIndicator.find('i').next().text(`${batteryLevel}%`)
      }

      // Add color class based on battery level
      batteryIndicator.removeClass('text-danger text-warning text-success')
      if (batteryLevel <= 10) {
        batteryIndicator.addClass('text-danger')
      } else if (batteryLevel <= 25) {
        batteryIndicator.addClass('text-warning')
      } else {
        batteryIndicator.addClass('text-success')
      }
    }
  }

  getBatteryIconLevel(batteryLevel) {
    if (batteryLevel <= 10) return 'empty'
    if (batteryLevel <= 25) return 'quarter'
    if (batteryLevel <= 50) return 'half'
    if (batteryLevel <= 75) return 'three-quarters'
    return 'full'
  }

  updatePhoneCount() {
    var count = $("#chat-who .phone-item").length
    $("#phone-count").text(count)
  }

  animatePhoneCount() {
    var badge = $("#phone-count")
    badge.addClass('updating')
    setTimeout(() => {
      badge.removeClass('updating')
    }, 300)
  }
}
